<div class="custom-security-link">
  <a [routerLink]="['/bulk-contacts']">Bulk Contact Actions</a>
  <a [routerLink]="['/archive-contacts']">Archive Contacts</a>
</div>

<!--<contact-common-search [execMapDuplicate]="true"></contact-common-search>-->
<contact-duplicate *ngIf="user && roleFeaturePermissions" [encryptedUser]="encryptedUser"  [user]=user [roleFeaturePermissions]="roleFeaturePermissions"></contact-duplicate>
